export default [
	{
		name: 'ELA',
		subject: 'ELA'
	},
	{
		name: 'Health & Wellness',
		subject: 'WB'
	},
	{
		name: 'Science',
		subject: 'Science'
	},
	{
		name: 'Social Studies',
		subject: 'Social Studies'
	},
	{
		name: 'Other',
		subject: 'other'
	},
]
